import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { UppKonvaModule } from '@unpispas/upp-konva';
import { DemoKonvaComponent } from './demo-konva.component';

/**
 * Demo solo con API de `model/` (`UppKonvaModel`, DTO `UppKonvaAreaSource`, host `upp-konva`).
 * Sin imports de `lib/stage/`. No forma parte del tarball npm de `@unpispas/upp-konva`.
 */
@NgModule({
  imports: [CommonModule, FormsModule, UppKonvaModule],
  declarations: [DemoKonvaComponent],
  exports: [DemoKonvaComponent],
})
export class UppKonvaDemoModule {}
